import "./PagemakerForAllIndustries.module.css";
import Header from "@/reusable_sections/Header";
import PerformanceRevolution from "./sections/PerformanceRevolution";
import GetInTouch from "./sections/GetInTouch";
import ProductRecommendations from "./sections/ProductRecommendations";
import TrustAndCredibility from "./sections/TrustAndCredibility";
import Hero from "./sections/Hero";
import Footer from "@/reusable_sections/Footer";
export default function PagemakerForAllIndustriesPage() {
  return <div>
      <Header />
      <PerformanceRevolution />
      <GetInTouch />
      <ProductRecommendations />
      <TrustAndCredibility />
      <Hero />
      <Footer />
    </div>;
}